// extracted by mini-css-extract-plugin
export default {"divWrapper":"Gallery_divWrapper__KLBsh","box":"Gallery_box__hEBlc","imgGallery":"Gallery_imgGallery__WGvxK"};